import {Component, EventEmitter, Inject, OnChanges, OnInit, Output} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {PbxAccountModel} from '../../../api/models/pbx-account-model';
import {NotificationService} from '../../../notification/notification.service';
import {LocalPbxService} from '../../local-pbx.service';
import {E911DetailsRequest} from '../../../api/models/e-911-details-request';
import {phoneNumberValidator} from '../../../core/validators/phone-number.validator';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatTextInputComponent } from '../../../editors/mat-text-input/mat-text-input.component';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

export interface RequestE911AddressData {
  pbxAccount: PbxAccountModel;
}

@Component({
    selector: 'app-request-e911-address',
    template: `
    <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
      <div fxFlex>Request new E-911 Address</div>
      <button mat-icon-button [mat-dialog-close]="false" class="button-40">
        <mat-icon>close</mat-icon>
      </button>
    </h1>
    <mat-dialog-content class="mat-typography">
      <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
          Error occurred
        </div>

        <div fxLayout="column" fxLayoutAlign="start center" [fxLayoutGap]="15">
          <app-mat-text-input fxFlex [formControl]="fullAddressControl" label="Full Address" name="fullAddress"
                                    placeholder="Type here full address for E-911"
                                    [submitted]="submitted">
          </app-mat-text-input>
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button [mat-dialog-close]="false">Cancel</button>
      <button mat-stroked-button color="primary" cdkFocusInitial (click)="onSubmit()" [promiseBtn]="buttonSubmitPromise">Submit
      </button>
    </mat-dialog-actions>
  `,
    styles: [],
    standalone: true,
    imports: [MatDialogTitle, FlexModule, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, NgIf, MatTextInputComponent, MatDialogActions, MatButton, Angular2PromiseButtonModule]
})
export class RequestE911AddressComponent implements OnInit, OnChanges {

  form: UntypedFormGroup;
  fullAddressControl = new UntypedFormControl('', [Validators.required]);
  public submitted: boolean;
  public serverError: boolean;
  buttonSubmitPromise: Promise<void>;

  onConfirm: Promise<void>;
  @Output() onSuccess = new EventEmitter<void>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: RequestE911AddressData,
              public dialogRef: MatDialogRef<RequestE911AddressComponent>,
              public dialog: MatDialog,
              public pbxService: LocalPbxService,
              private fb: UntypedFormBuilder,
              private notificationService: NotificationService) {
    this.createForm();
  }

  ngOnInit(): void {
    this.ngOnChanges();
  }

  ngOnChanges() {
    this.submitted = false;
    this.form.reset({
      'fullAddress': '',
      'telephoneNumber': ''
    });
  }

  async onSubmit() {
    this.submitted = true;
    this.serverError = false;

    if (this.form.valid) {
      this.buttonSubmitPromise = this.processSubmit();
    }
  }

  async processSubmit(): Promise<void> {
    const reqData = this.prepareFormModel();

    if (await this.pbxService.requestE911Addresses(reqData)) {
      this.notificationService.notifySuccess('The changes have been submitted successfully');

      this.dialogRef.close('success');

      this.ngOnChanges();
    } else {
      this.serverError = true;
    }
  }

  prepareFormModel(): E911DetailsRequest {
    const formModel = this.form.value;
    return {
      fullAddress: formModel.fullAddress,
      telephoneNumber: '',
      extension: this.data.pbxAccount.name,
      callerName: ''
    };
  }

  createForm(): void {
    this.form = this.fb.group({
        'fullAddress': this.fullAddressControl
      }
    );
  }
}
